import { useEffect, useState, useMemo } from 'react'
import { UserContext } from './UserContext'
import { DEFAULT_USER } from '../../constants'

export function UserProvider({ children }) {
    const [currentUser, setCurrentUser] = useState({
        ...DEFAULT_USER,
        isLoggedIn: false,
        loading: true
    })

    useEffect(() => {
        fetch('/api/auth/user', {
            method: 'GET',
            headers: {
                'X-CSRF-PROTECTION': '1',
            }
        })
            .then((response) => {
                if (response.status === 200) return response.json()
                console.error('Error loadign user', response)
            })
            .then((responseUser) => {
                if (responseUser?.id)
                    setCurrentUser({
                        ...responseUser,
                        isLoggedIn: true,
                        loading: false
                    })
                else
                    setCurrentUser({
                        ...DEFAULT_USER,
                        isLoggedIn: false,
                        loading: false
                    })
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const enhancedUser = useMemo(
        () => ({
            ...currentUser,
            hasRole: (...roles) => {
                return roles.some((role) => {
                    return !!currentUser.roles[role]
                })
            },
            logout: () => {
                setCurrentUser({
                    ...DEFAULT_USER,
                    isLoggedIn: false,
                    loading: false
                })
                fetch('/api/auth/signout', {
                    method: 'GET',
                    headers: {
                        'X-CSRF-PROTECTION': '1',
                    }
                })
            },
            login: () => {
                fetch('/api/auth/user', {
                    method: 'GET',
                    headers: {
                        'X-CSRF-PROTECTION': '1',
                    }
                })
                    .then((response) => {
                        if (response.status === 200) return response.json()
                        console.error('Error loadign user', response)
                    })
                    .then((responseUser) => {
                        if (responseUser?.id)
                            setCurrentUser({
                                ...responseUser,
                                isLoggedIn: true,
                                loading: false
                            })
                        else
                            setCurrentUser({
                                ...DEFAULT_USER,
                                isLoggedIn: false,
                                loading: false
                            })
                    })
            }
        }),
        [currentUser]
    )

    return (
        <UserContext.Provider value={enhancedUser}>
            {children}
        </UserContext.Provider>
    )
}
